import React, { useState } from "react";
import { image_proof, view } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import moment from "moment";

const SingleTable2 = ({ WorkCompleted }) => {
  const [popup, setPopup] = useState(false);

  const roles = [
    {
      id: "Admin",
      name: "midhun",
      description: "Full access to all features",
      serialNo: "12345",
      closeDateTime: "2025-10-14 10:30 AM",
      assignBy: "Robert",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", // your YouTube link here
      proof: [
        { img: image_proof },
        { img: image_proof },
        { img: image_proof },
        { img: image_proof },
      ],
    },
  ];

  const handlePlayClick = (url) => {
    window.open(url, "_blank");
  };

  const handleImageClick = (img) => {
    window.open(img, "_blank");
  };

  return (
    <div className="role-table-container my-3 py-3">
      <table className="role-table ">
        <thead>
          <tr>
            <th>Role</th>
            <th>Name</th>
            <th>Description</th>
            <th>
              Close <br /> Date & Time
            </th>
            <th>Assign By</th>
            {/* <th>Proof</th> */}
          </tr>
        </thead>
        <tbody>
          {/* {roles.map((role, index) => ( */}
          <tr >
            <td>{WorkCompleted?.assigned_to?.role == 1 ? "Super Admin" : WorkCompleted?.assigned_to?.role == 2 ? "Inventory" : WorkCompleted?.assigned_to?.role == 3 ? "Technical" : WorkCompleted?.assigned_to?.role == 4 ? "Regional Manager" : WorkCompleted?.assigned_to?.role == 5 ? "Service Engineer" : "-"}</td>
            <td>{WorkCompleted?.assigned_to?.name || "-"}</td>
            <td>{WorkCompleted?.remarks || "-"}</td>
            <td>{moment(WorkCompleted?.updated_at).format("DD-MM-YYYY - hh:mm A ") || "-"}</td>
            <td>{WorkCompleted?.assigned_by?.name || "-"}</td>
            {/* <td>
                <button onClick={() => setPopup(true)} className="cust-btn">
                  <img src={view} alt="View" className="editor-btn" />
                </button>
              </td> */}
          </tr>
        </tbody>
      </table>

      {/* {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <p className="popup-close-btn" onClick={() => setPopup(false)}>
                <CloseIcon />
              </p>
            </div>

            <div className="video-section">
              <label
                style={{ color: "#323691", fontWeight: "bold" }}
                className="d-flex ac-js mb-2"
              >
                Video Proof
              </label>
              <div
                className="video-proof-box"
                onClick={() => handlePlayClick(roles[0].videoUrl)}
                style={{ cursor: "pointer" }}
              >
                <PlayArrowIcon className="play-icon" />
              </div>
            </div>

      <div className="images-section">
        <label
          className="d-flex ac-js my-2"
          style={{
            color: "#323691",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          Image Proof
        </label>
        <div className="d-flex ac-js gap-3">
          {roles[0].proof.map((p, i) => (
            <img
              key={i}
              src={p.img}
              className="image_proof"
              alt={`proof-${i}`}
              style={{
                cursor: "pointer",
                width: "100px",
                height: "100px",
              }}
              onClick={() => handleImageClick(p.img)}
            />
          ))}
        </div>
      </div>
    </div>
        </div >
      )} */}
    </div >
  );
};

export default SingleTable2;
